import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-footer-section',
  templateUrl: './footer-section.component.html',
  styleUrl: './footer-section.component.scss',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule],
})
export class FooterSectionComponent {
  year = new Date().getFullYear();
}
